import React from 'react';
import { connect } from 'react-redux';
import { translate } from 'react-i18next';
import { Button, Modal } from 'react-bootstrap';
import CoolingTowerDetail from '../../components/ac_central/CoolingTowerDetail';
import { defaultRejectHandler } from '../../utils/utility';
import {
  getCoolingTower,
  editCoolingTower,
} from '../../redux/ac_central/cooling_tower_actions';

class CoolingTowerEditModal extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isValid: false,
      isDirty: false,
      isSubmittable: false,
    };

    this.ctDetail = undefined;
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.ct !== nextProps.ct && nextProps.show) {
      this.props.getCoolingTower(nextProps.ct.id);
    }
  }

  onSaveHandler() {
    const editedWP = this.ctDetail.getWrappedInstance().getWrappedInstance().getCTData();
    this.props.editCoolingTower({
      ...editedWP,
      id: this.props.ct.id,
    });
  }

  render() {
    const { isEditing, errorMessage, ctDetail, t, getCoolingTower, editCoolingTower, ...newProps } = this.props;
    const { isSubmittable } = this.state;
    return (
      <Modal
        {...newProps}
        bsSize="large"
        aria-labelledby="contained-modal-title-lg"
        backdrop="static"
      >
        <Modal.Header closeButton>
          <Modal.Title>{t('edit cooling tower')}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <CoolingTowerDetail
            ct={ctDetail}
            ref={ref => (this.ctDetail = ref)}
            onValid={isValid => this.setState({ isValid })}
            onDirty={isDirty => this.setState({ isDirty })}
            onSubmittable={isSubmittable => this.setState({ isSubmittable })}
            fieldErrors={errorMessage}
            onSubmit={() => !this.props.isEditing && !this.props.isEdited && this.onSaveHandler()}
          />
        </Modal.Body>
        <Modal.Footer>
          <Button
            id="air-conditioning-cooling-tower-submit-edit"
            disabled={!isSubmittable || isEditing}
            onClick={() => this.onSaveHandler()}
          >
            {isEditing ? `${t('saving')}...` : t('save')}
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }
}

const mapStateToProps = (state, props) => ({
  errorMessage: state.ac.coolingTower.errorMessage,
  isEditing: state.ac.coolingTower.isEditing,
  ctDetail: props.ct && state.ac.coolingTower.objects[props.ct.id],
});

const mapDispatchToProps = dispatch => ({
  editCoolingTower: ct => defaultRejectHandler(dispatch(editCoolingTower(ct.id, ct.name, ct.cooling_capacity, ct.unit, ct.power_required, ct.description, ct.image))),
  getCoolingTower: id => defaultRejectHandler(dispatch(getCoolingTower(id))),
});

export default translate('translations')(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  )(CoolingTowerEditModal),
);



// WEBPACK FOOTER //
// ./src/modal/ac_central/CoolingTowerEditModal.js